export const TR_MONTHS = [
  'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
  'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'
];

/** Bugünün ayını "YYYY-MM" formatında döner */
export const currentMonthValue = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
};

/**
 * E-posta / mutabakat ay seçimi için son N ayı (bugünden geriye) üretir.
 * @returns {{ value: string, label: string }[]}  value: "2026-08", label: "Ağustos 2026"
 */
export const buildMonthOptions = (count = 18) => {
  const options = [];
  const now = new Date();
  for (let i = 0; i < count; i++) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const value = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
    options.push({ value, label: `${TR_MONTHS[d.getMonth()]} ${d.getFullYear()}` });
  }
  return options;
};

/**
 * "YYYY-MM" değerinden ayın ilk/son gününü ve okunabilir etiketini üretir.
 * @returns {{ startDate: string, endDate: string, monthName: string, year: number, lastDay: number, rangeLabel: string } | null}
 */
export const monthToPeriod = (monthValue) => {
  const [yStr, mStr] = String(monthValue || '').split('-');
  const year = parseInt(yStr, 10);
  const month = parseInt(mStr, 10); // 1-12
  if (!year || !month || month < 1 || month > 12) return null;

  const lastDay = new Date(year, month, 0).getDate();
  const mm = String(month).padStart(2, '0');
  const monthName = TR_MONTHS[month - 1];

  return {
    startDate: `${year}-${mm}-01`,
    endDate: `${year}-${mm}-${String(lastDay).padStart(2, '0')}`,
    monthName,
    year,
    lastDay,
    rangeLabel: `01.${mm}.${year} - ${String(lastDay).padStart(2, '0')}.${mm}.${year}`
  };
};
